import React from 'react';
import { Result, Button } from 'antd';
import { CrownOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/** True for the account owner (and super admins). Billing and managing the team are not for team members. */
export const isAccountOwner = (user) => !!user && (user.is_account_admin === true || user.is_super_admin === true);

/**
 * Pages for the account owner only (billing, adding or editing team members). Team members see
 * a notice instead. A locked or expired account also sends members to the upgrade page.
 */
const OwnerOnly = ({
  children,
  title = 'Billing is managed by the account owner',
  subTitle = 'The plan, invoices and upgrades are handled by the owner of this account. If the account is locked or expired, ask them to renew it.',
}) => {
  const { user } = useAuth();
  const navigate = useNavigate();

  if (isAccountOwner(user)) return children;

  return (
    <Result
      icon={<CrownOutlined />}
      title={title}
      subTitle={subTitle}
      extra={<Button type="primary" onClick={() => navigate('/')}>Go to dashboard</Button>}
    />
  );
};

export default OwnerOnly;
